import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  HostListener,
  Inject,
  OnInit,
} from '@angular/core';

import { AnimationEvent } from '@angular/animations';
import { NavigationEnd, Router } from '@angular/router';
import { filter, take } from 'rxjs';
import { slide } from './notification-bar-animation';
import {
  DefaultNotificationBardData,
  NOTIFICATION_BAR_DATA,
  NotificationBarData,
} from './notification-bar-data.model';
import { NotificationBarRef } from './notification-bar-ref';

const OpenState = {
  Opened: 'opened',
  Closed: 'closed',
} as const;

@Component({
    selector: 'lui-notification-bar',
    templateUrl: './notification-bar.component.html',
    styleUrls: ['./notification-bar.component.scss'],
    animations: [slide],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NotificationBarComponent implements OnInit {
  iconColor: string;
  icon: string | undefined;
  message: string;
  primaryButtonText: string | undefined;

  openState = true;
  value = false;
  closeOnNavigation;
  // private animationClosedSubject = new Subject<boolean>();

  @HostBinding('@slide') get slideAnimation() {
    return this.openState ? OpenState.Opened : OpenState.Closed;
  }

  @HostListener('@slide.done', ['$event']) _transformEnded(e: AnimationEvent) {
    if (e.toState === OpenState.Closed) {
      this.ref.close(this.value);
    }
  }

  constructor(
    @Inject(NOTIFICATION_BAR_DATA) public data: NotificationBarData,
    private ref: NotificationBarRef,
    private router: Router
  ) {
    this.iconColor = data.iconColor || DefaultNotificationBardData.iconColor;
    this.icon = data.icon;
    this.message = data.message || DefaultNotificationBardData.message;
    this.primaryButtonText = data.primaryButtonText;
    this.closeOnNavigation = data.closeOnNavigation || false;
  }

  ngOnInit(): void {
    if (this.closeOnNavigation) {
      this.router.events
        .pipe(
          filter((e) => e instanceof NavigationEnd),
          take(1)
        )
        .subscribe(() => {
          this.close();
        });
    }
  }

  dismiss() {
    this.close();
  }

  primaryAction() {
    this.close(true);
  }

  private close(v = false) {
    this.openState = false;
    this.value = v;
  }
}
